import React from 'react';
import PropTypes from 'prop-types';
import colors from '@general/colors';

const chipColorClass = color => {
    if (color === 'aqua') {
        return { backgroundColor: '#D4ECEE' };
    }

    if (color === 'brightSun') {
        return { backgroundColor: '#FAD536' };
    }

    if (color === 'emerald') {
        return { backgroundColor: '#BDEDD7' };
    }

    if (color === 'red') {
        return { backgroundColor: '#F1A79E' };
    }

    if (color === 'yellow') {
        return { backgroundColor: '#FDEA9B' };
    }

    return { backgroundColor: '#D4ECEE' };
};

const CardChip = ({ children, color = 'aqua', className, style = {} }) => {
    const baseStyle = {
        borderRadius: '2.3rem',
        fontSize: '12px',
        fontFamily: 'Red Hat Display',
        lineHeight: 'normal',
        fontWeight: 400,
        color: colors.black,
        padding: '0.2rem 1.25rem',
    };

    const styles = {
        ...baseStyle,
        ...chipColorClass(color),
        ...style,
    };

    return (
        <div className={`d-inline-block text-center align-middle ${className}`} style={styles}>
            {children}
        </div>
    );
};

CardChip.propTypes = {
    children: PropTypes.node,
    color: PropTypes.string,
    className: PropTypes.string,
    style: PropTypes.object,
};

export default CardChip;
